import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { LayoutConfig } from '@core/models/layout.model';
import { LayoutService } from '@core/services/layout.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { filter } from 'rxjs';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'y-project-my';
  private router = inject(Router);
  layout = inject(LayoutService);
  readonly swUpdate = inject(SwUpdate);
  snackBarService = inject(SnackBarService);
  themeService = inject(ThemeService);
  constructor() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(evt => {
        switch (evt.type) {
          case 'VERSION_DETECTED':
            break;
          case 'VERSION_READY':
            this.snackBarService.default({
              message: `🆕 A new version of the app is available! 🔢 Current version: ${evt.currentVersion.hash} 🚀 New version: ${evt.latestVersion.hash} Please refresh to update.`,
            });
            this.promptUserForUpdate();
            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
            break;
        }
      });
    }
  }
  promptUserForUpdate() {
    if (confirm('A new version is available! Do you want to update now?')) {
      this.activateNewVersion();
    }
  }
  activateNewVersion() {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }
  ngOnInit() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const snapshot = this.router.routerState.snapshot;
      const route = this.findDeepestRoute(snapshot.root);
      const layoutConfig: Partial<LayoutConfig> = route.data?.['layout'] ?? {};

      this.layout.applyLayout({ ...layoutConfig });
    });
  }

  private findDeepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    while (route.firstChild) route = route.firstChild;
    return route;
  }
}
